// @ts-nocheck
/**
 * tablePayloadMigration.ts — Migrate legacy single-field table payloads to dual binds.
 *
 * Pre-DEC dual-bind layout tables used one `table.source` for both list-backed and
 * CTBL/fileTable paths. Charts already split `source` vs `tableSource`; tables now match.
 */

/**
 * True when a ValueSource looks like a live table / fileTable bind (or static blob),
 * not a DEC-077 list/variable matrix.
 */
export function isLegacyTablePropertySource(source: unknown): boolean {
  if (source == null || typeof source !== 'object') return false;
  const vs = source as { kind?: string; ref?: { kind?: string }; value?: unknown };
  if (vs.kind === 'binding' && vs.ref?.kind === 'categoryProperty') return true;
  if (vs.kind === 'static' && typeof vs.value === 'string') return true;
  return false;
}

/**
 * Mutate a table payload in place:
 * - Move legacy categoryProperty / static-string `source` → `tableSource` when `tableSource` is absent.
 * - Leave localState / itemVariable list binds on `source`.
 */
export function migrateTablePayloadInPlace(table: Record<string, unknown>): void {
  if (table.tableSource != null) return;
  const source = table.source;
  if (!isLegacyTablePropertySource(source)) return;
  table.tableSource = source;
  delete table.source;
}
